import FontFaceObserver from 'fontfaceobserver/fontfaceobserver.standalone'

export default {
  sofia: {
    bold: new FontFaceObserver('sofia-pro', { weight: 700 })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/_fonts.js